import styled from 'styled-components';
import PropTypes from 'prop-types';
import BaseBox from '../../../../design/BaseBox';

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 300px;
`;

export const Box = styled(BaseBox)`
  width: ${props => props.width || '100%'};
`;

Box.propTypes = {
  width: PropTypes.string
};
